import * as XLSX from "xlsx";
import { calculateTotals } from "../utils/pricingUtils";
const exportToExcel = (updateDetails, styleNumber) => {
  // Collect all the table data
  const data = [];
  const img = [];
  const styleNumbers = [];

  updateDetails.forEach((details, subIndex) => {
    const { totalLHSAmt, totalRHSAmt, marginPercentage } = calculateTotals(
      details.stoneDetails,
      details
    );

    const fileName = details.styleNo;
    // Check if the current details entry matches the desired style number
    if (fileName === styleNumber) {
      styleNumbers.push(fileName);

      details.stoneDetails.forEach((stoneDetails, subIndex) => {
        const rowData = {
          styleNo: details.styleNo,
          Com_Name: stoneDetails.comName,
          Sieve_Size: stoneDetails.sieveSize,
          MMSize: stoneDetails.mmSize,
          PPWt: stoneDetails.ppwt,
          Pcs: stoneDetails.pcCount,
          SettType: stoneDetails.settingType,
          LotCode: stoneDetails.lotCode,
          LHSMaxCts: stoneDetails.maxCts,
          LHSRate: stoneDetails.lhsRate,
          LHSAmt: stoneDetails.lhsAmt,
          RHSMaxCts: stoneDetails.rhsMaxCts,
          RHSRate: stoneDetails.rhsRate,
          RHSAmt: stoneDetails.rhsAmt,
          CustomerMatser: stoneDetails.cusmaster,
          ClientStone: stoneDetails.isClientStone,
        };
        data.push(rowData);

        // Update totalLHSAmt, totalRHSAmt, and marginPercentage
      });

      // Add total and margin to the data
      const totalRow = {
        styleNo: "Total",
        LHSAmt: totalLHSAmt,
        RHSAmt: totalRHSAmt,
        MarginPercentage: marginPercentage,
      };
      data.push(totalRow);

      // Add an empty row
      const emptyRow = {
        styleNo: "",
        Com_Name: "",
        Sieve_Size: "",
        MMSize: "",
        PPWt: "",
        Pcs: "",
        SettType: "",
        LotCode: "",
        LHSMaxCts: "",
        LHSRate: "",
        LHSAmt: "",
        RHSMaxCts: "",
        RHSRate: "",
        RHSAmt: "",
        CustomerMatser: "",
        ClientStone: "",
      };
      data.push(emptyRow);
    }
    const imgData = details.stoneDetails[0].url; // Assuming this is the url of the image
    img.push(imgData);
  });

  // Create a worksheet
  const ws = XLSX.utils.json_to_sheet(data);

  // Create a workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  // Save the workbook to a file
  const excelFileName = `${styleNumber}.xlsx`;
  XLSX.writeFile(wb, excelFileName);
};

//=============================================================================//

const handleAllExcelDownload = (details) => {
  const currentDate = new Date();
  const monthName = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
    currentDate
  );
  const day = currentDate.getDate();
  let hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  // Convert hours to 12-hour format
  hours = hours % 12 || 12;
  // Format the date as "MonthName Day, Year"
  const formattedDate = `${monthName}/${day}/${currentDate.getFullYear()} --${hours}:${minutes}:${ampm}`;
  const data = [];

  if (details.data && details.data.priceDetails?.length > 0) {
    details.data.priceDetails?.forEach((detail, subIndex) => {
      let { totalLHSAmt, totalRHSAmt, marginPercentage } = calculateTotals(
        detail.stoneDetails,
        detail
      );
      const fileName = detail.styleNo;

      // Check if the current detail entry matches the desired style number
      if (fileName) {
        detail.stoneDetails.forEach((stoneDetail, subIndex) => {
          const rowData = {
            styleNo: detail.styleNo,
            Com_Name: stoneDetail.comName,
            Shape: stoneDetail.shapeCode,
            Sieve_Size: stoneDetail.sieveSize,
            MMSize: stoneDetail.mmSize,
            PPWt: stoneDetail.ppwt,
            Pcs: stoneDetail.pcCount,
            SettType: stoneDetail.settingType,
            LotCode: stoneDetail.lotCode,
            LHSMaxCts: stoneDetail.maxCts,
            LHSRate: stoneDetail.lhsRate,
            LHSAmt: stoneDetail.lhsAmt,
            RHSMaxCts: stoneDetail.rhsMaxCts,
            RHSRate: stoneDetail.rhsRate,
            RHSAmt: stoneDetail.rhsAmt,
            CustomerMatser: stoneDetail.cusmaster,
            ClientStone: stoneDetail.isClientStone,
          };
          data.push(rowData);
        });
        // Add total and margin to the data
        const totalRow = {
          styleNo: "Total",
          LHSAmt: totalLHSAmt,
          RHSAmt: totalRHSAmt,
          MarginPercentage: marginPercentage,
        };
        data.push(totalRow);
        // Add an empty row
        const emptyRow = {
          styleNo: "",
          Com_Name: "",
          Shape: "",
          Sieve_Size: "",
          MMSize: "",
          PPWt: "",
          Pcs: "",
          SettType: "",
          LotCode: "",
          LHSMaxCts: "",
          LHSRate: "",
          LHSAmt: "",
          RHSMaxCts: "",
          RHSRate: "",
          RHSAmt: "",
          CustomerMatser: "",
          ClientStone: "",
        };
        data.push(emptyRow);
      }
    });
  }

  const ws = XLSX.utils.json_to_sheet(data);

  // Apply styling to the header cells
  ws["!cols"] = [
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
    { width: 25 },
  ];
  // Use let instead of const for these properties
  let headerStyleA1 = { fill: { bgColor: "#FF0000" }, font: { bold: true } };
  let headerStyleB1 = {
    fill: { bgColor: { rgb: "FF0000" } },
    font: { bold: true },
  };
  // Add styling to other header cells as needed
  ws["A1"].s = headerStyleA1;
  ws["B1"].s = headerStyleB1;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  // Save the workbook to a file
  const excelFileName = `${details.data.pricingNo}_${formattedDate}.xlsx`;
  XLSX.writeFile(wb, excelFileName);
};

//download excel format data for pricingChart module

const downloadDataInExcel = (details) => {
  // console.log("🚀 ~ downloadDataInExcel ~ details:", details);
  const currentDate = new Date();
  const monthName = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
    currentDate
  );
  const day = currentDate.getDate();
  let hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  // Convert hours to 12-hour format
  hours = hours % 12 || 12;
  // Format the date as "MonthName Day, Year"
  const formattedDate = `${monthName}/${day}/${currentDate.getFullYear()} --${hours}:${minutes}:${ampm}`;
  const data = [];

  details?.forEach((details) => {
    // console.log("detailssss-------", details);
    const rowData = {
      // Clarity: details.Clarity,
      // Color: details.Color,
      // CustomerQuality: details.CustomerQuality,
      // InternalQuality: details.InternalQuality,

      //MMSize: details.MMSize,
      // RM: details.RM,
      // Shape: details.Shape,
      // SieveSize: details.SieveSize,
      //SizeGroup: details.SieveSize,
      lotCodeId: details._id,
      LotCode: details.LotCode,
      MCP: details.MCP,
      SalesPrice: details.SalesPrice,
      //addByDMS: details.addByDMS ? "Yes" : "No",
    };

    data.push(rowData);
  });

  const ws = XLSX.utils.json_to_sheet(data);

  // Apply styling to the header cells
  ws["A1"].S = { fill: { bgColor: { rgb: "#FF0000" } }, font: { bold: true } };
  // ws["B1"].s = { fill: { bgColor: { rgb: "#FF0000" } }, font: { bold: true } };

  // Set column widths
  ws["!cols"] = [
    { width: 25 },
    { width: 25 },
    { width: 15 },
    { width: 15 },
    // { width: 20 },
    // { width: 20 },
    // { width: 20 },
    // { width: 20 },
    // { width: 20 },
    // { width: 20 },
    // { width: 20 },
    // { width: 20 },
    // { width: 10 },
    // { width: 10 },
    // { width: 10 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  // Save the workbook to a file
  const excelFileName = `${details[0].Commodity}_${formattedDate}.xlsx`;
  XLSX.writeFile(wb, excelFileName);
};

// update customer chart details through excel

export { exportToExcel, handleAllExcelDownload, downloadDataInExcel }; // Export as default
